import {
    ListColumnsFactoryComponent,
    ListConfigFieldTypes,
    ListConfigNamedColumn
} from '../../../@types/components/List';
import {IListColumnsFactory} from '../../../@interfaces/components/List/IListColumnsFactory';
import {wellKnownColumns} from '../wellKnownColumns';

export default class ListColumnsFactory implements IListColumnsFactory {
    protected wellKnownColumns: Record<Partial<ListConfigFieldTypes>, ListColumnsFactoryComponent> = wellKnownColumns;

    protected customComponentAccessor?: (config: ListConfigNamedColumn) => ListColumnsFactoryComponent | null;

    setCustomComponentAccessor(accessor: (config: ListConfigNamedColumn) => ListColumnsFactoryComponent | null): void {
        this.customComponentAccessor = accessor;
    }

    getComponent(config: ListConfigNamedColumn): ListColumnsFactoryComponent {
        if (this.customComponentAccessor) {
            const component = this.customComponentAccessor(config);
            if (component) {
                return component;
            }
        }

        const type = config.type;
        if (type in this.wellKnownColumns) {
            return this.wellKnownColumns[type];
        }

        return this.wellKnownColumns.text;
    }
}
